<script>
export default {
  props: {
    blankWidth: {
      type: String,
      default: '50px',
    },
    blankHeight: {
      type: String,
      default: '50px',
    },
    blankX: {
      type: String,
      default: '0',
    },
    blankY: {
      type: String,
      default: '0',
    },
  },
  methods: {
    spitStyle() {
      return (
        'width: ' +
        this.blankWidth +
        '; height: ' +
        this.blankHeight +
        '; top: ' +
        this.blankY +
        ' ; right: ' +
        this.blankX +
        ';'
      )
    },
  },
}
</script>

<template>
  <div class="blankButton" :style="spitStyle()" />
</template>

<style lang="scss">
.blankButton {
  position: absolute;
  z-index: 50;
  cursor: pointer;
  background: transparent;
}
</style>
